import { defineStore } from 'pinia';

export const useUiStore = defineStore('ui', {
  state: () => ({
    client: 'sf',
    hasNavbar: false,
    headerClasses: '',
    debugMessage: '',
    isErrorBanner: false,
    isFatalError: false,
    // Ошибка создания пользователя в БУС (/api/user/add), блокирует кабинет
    userCreateError: null as null | { code: string | number; time: string; message: string },
  }),
  actions: {
    enableFatalError() {
      this.isFatalError = true;
    },
    enableUserCreateError(payload: { code: string | number; time: string; message: string }) {
      this.userCreateError = payload;
    },
    routeChanged(route: any) {
      this.hasNavbar = !['GetCard', 'Product', 'InviteForm'].includes(route.name);
    },
    setHeaderClasses(classes: string) {
      this.headerClasses = classes;
    },
    setIsErrorBanner(payload: any) {
      this.isErrorBanner = payload;
    },
  },
});
